import React, {Component} from 'react'

class AdditionalTalentNotesBox extends Component {
  render() {
    return (
      <div className="col-md-6 widget">
        <div className="title">Additional talent notes</div>
        <div className="row">
          <div className="col-12 additional-talent-notes">
            {this.props.additionalNotes}
          </div>
        </div>
      </div>
    )
  }
}

export default AdditionalTalentNotesBox